import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { DBDef_FHIRQuery } from './db-def.js';
export const ApiDef_FHIRQuery = {
    _v1: {
        createFromJSON: { method: HttpMethod.POST, path: `/v1/${DBDef_FHIRQuery.dbKey}/create-from-json` }
    }
};
//# sourceMappingURL=api-def.js.map